/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconCursorLeftSolidComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 10 14">
    <g id="Page-1" stroke="none">
    <g id="keypad/elementary" transform="translate(-19.000000, -17.000000)">
        <polygon id="Triangle-Copy" transform="translate(24.000000, 24.000000) rotate(-90.000000) translate(-24.000000, -24.000000) " points="24 19 31 29 17 29" />
    </g>
</g>
  </Icon>
);
};

IconCursorLeftSolidComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAgMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIj4KICAgIDxnIGlkPSJrZXlwYWQvZWxlbWVudGFyeSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE5LjAwMDAwMCwgLTE3LjAwMDAwMCkiPgogICAgICA8cG9seWdvbiBpZD0iVHJpYW5nbGUtQ29weSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQuMDAwMDAwLCAyNC4wMDAwMDApIHJvdGF0ZSgtOTAuMDAwMDAwKSB0cmFuc2xhdGUoLTI0LjAwMDAwMCwgLTI0LjAwMDAwMCkgIiBwb2ludHM9IjI0IDE5IDMxIDI5IDE3IDI5Ii8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4=";
IconCursorLeftSolidComponent.Content = `<svg viewBox="0 0 10 14" xmlns="http://www.w3.org/2000/svg">
  <g id="Page-1" stroke="none">
    <g id="keypad/elementary" transform="translate(-19.000000, -17.000000)">
      <polygon id="Triangle-Copy" transform="translate(24.000000, 24.000000) rotate(-90.000000) translate(-24.000000, -24.000000) " points="24 19 31 29 17 29"/>
    </g>
  </g>
</svg>`;

const IconCursorLeftSolid = styled(IconCursorLeftSolidComponent)``;

export default IconCursorLeftSolid;
